export default __webpack_public_path__ + "static/media/478.f0b0eb07.svg";